import { Head, Link } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Vendor {
  id: number
  display_name: string
}

interface Contact {
  id: number
  display_name: string
  title: string | null
  phone: string | null
  cell_phone: string | null
  email: string | null
  city: string | null
  state: string | null
}

interface Props {
  vendor: Vendor
  contacts: Contact[]
}

export default function Index({ vendor, contacts }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Subcontractors", href: "/company/vendors" },
    { title: vendor.display_name, href: `/company/vendors/${vendor.id}` },
    { title: "Contacts", href: `/company/vendors/${vendor.id}/contacts` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`${vendor.display_name} - Contacts`} />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">
            Contacts for {vendor.display_name}
          </h1>
          <Link
            href={`/company/vendors/${vendor.id}/contacts/new`}
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Contact
          </Link>
        </div>

        {contacts.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Name
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Title
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Phone
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Email
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact) => (
                <tr key={contact.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/company/vendors/${vendor.id}/contacts/${contact.id}`}
                      className="text-hpi-active-blue hover:text-hpi-active-blue"
                    >
                      {contact.display_name}
                    </Link>
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {contact.title}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {contact.phone ?? contact.cell_phone}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {contact.email}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/company/vendors/${vendor.id}/contacts/${contact.id}/edit`}
                      className="text-hpi-active-blue hover:text-hpi-active-blue"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No contacts found.</p>
        )}
      </div>
    </AppLayout>
  )
}
